import { NgModule } from "@angular/core";
import { UploadFileFormComponent } from './upload-file-form/upload-file-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { DynamicUploadFileComponent } from './dynamic-upload-file.component';
import { UploadFileDesignComponent } from './upload-file-design/upload-file-design.component';
import { UploadFileResultComponent } from './upload-file-result/upload-file-result.component';

@NgModule({
    declarations: [
        DynamicUploadFileComponent, UploadFileFormComponent, UploadFileDesignComponent, UploadFileResultComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule
    ],
    entryComponents: [
        DynamicUploadFileComponent
    ]
})
export class UploadFileModule {}